import React from 'react'
import Icons from '../../../assets/icons/index'
import styled from './RequestProductDetail.module.css'

const ProductTable = ({ status , data}) => {
    console.log("SLLLLL",status)
    return (
        <table className={styled.table}>
            <thead className="text-left">
                <tr className={styled.table_header_row}>
                    <th className="">Product</th>
                    <th>Product No.</th>
                    <th>Price</th>
                    <th>Product Type</th>
                    {
                        status != 'pending' &&
                        <>
                            <th>Status</th>
                            <th>Receive</th>
                        </>
                    }
                    <th className="w-2/12"></th>

                </tr>
            </thead>
            <tbody>
                {
                    data?.length > 0 ? data?.map((item, index) => (
                        <tr className="h-[64px] border-b border-b-black-2" key={index}>
                            <td>
                                {item?.image ?
                                 <img src={item?.image} alt="" className="w-[56px] h-[48px]" />
                                 :
                                 <img src={Icons.defaultImage} alt="" className="w-[56px] h-[48px]" />
                                }
                               
                            </td>
                            <td className={`${styled.table_body_column} font-interSemiBold cursor-pointer`}>{item?.product?.name ? item?.product?.name : '-'}</td>
                            <td className={`${styled.table_body_column} font-interRegular`}>{item?.product?.price ? item?.product?.price : ''}</td>
                            <td className={`${styled.table_body_column} font-interRegular`}>{item?.product_type?.name ? item?.product_type?.name : '-'}</td>
                            <td className={styled.table_body_column}>
                                {
                                   item?.is_accepted ?
                                    <div className={styled.accepted}>
                                        <span>Accepted</span>
                                    </div>
                                    :
                                    <p>_</p>
                                }
                            </td>
                            <td className={styled.table_body_column}>
                                {
                                    item?.is_received ?
                                    <div className={styled.received}>
                                        <span>Received</span>
                                    </div>
                                    : <p>_</p>
                                }
                            </td>

                        </tr>
                    )) :
                    <div className='mt-3'>
                        <p className='text-center'>There is no data.</p>
                    </div>
                }
            </tbody>
        </table>
    )
}
export default ProductTable